export const CourseHead = require("./CourseHead").default;
export const PushHead = require("./PushHead").default;
export const CommonHead = require("./CommonHead").default;
export const DealBtn = require("./DealBtn").default;
export const DealBtnPark = require("./DealBtnPark").default;
export const Comment = require("./Comment").default;
export const CommentList = require("./Comment/CommentList").default;
export const form = require("./form");